import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);

  // Detect mobile viewport and scroll position
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 992);
    };

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    // Initial checks
    checkIfMobile();
    handleScroll();

    // Event listeners
    window.addEventListener('resize', checkIfMobile);
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('resize', checkIfMobile);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setOpenSubmenu(null);
  };

  const toggleSubmenu = (menuName) => {
    setOpenSubmenu(openSubmenu === menuName ? null : menuName);
  };

  // Mobile styles
  const mobileStyles = {
    menuArea: {
      position: 'fixed',
      // top: '80px',
      left: isMenuOpen ? 0 : '-100%',
      width: '280px',
      height: '100vh',
      backgroundColor: '#ffffff',
      transition: 'all 0.3s ease-out',
      zIndex: 1001,
      padding: '20px',
      boxShadow: '2px 0 10px rgba(0,0,0,0.1)',
      overflowY: 'auto'
    },
    closeButton: {
      position: 'absolute',
      top: '20px',
      right: '20px',
      fontSize: '24px',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      color: '#333'
    },
    menuList: {
      listStyle: 'none',
      padding: '0px 0 0',
      margin: 0
    },
    menuItem: {
      padding: '12px 0',
      borderBottom: '1px solid #f0f0f0',
      position: 'relative'
    },
    submenu: {
      listStyle: 'none',
      padding: '10px 0 0 15px',
      margin: 0,
      display: openSubmenu ? 'block' : 'none'
    },
    hamburger: {
      cursor: 'pointer',
      zIndex: 1002,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: '30px',
      height: '30px',
      marginRight: '15px'
    },
    hamburgerLine: {
      display: 'block',
      width: '25px',
      height: '3px',
      backgroundColor: '#000000',
      margin: '4px 0',
      transition: 'all 0.3s ease',
      transformOrigin: 'center'
    },
    overlay: {
      position: 'fixed',
      top: '80px',
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      zIndex: 1000,
      opacity: isMenuOpen ? 1 : 0,
      visibility: isMenuOpen ? 'visible' : 'hidden',
      transition: 'all 0.3s ease'
    },
    submenuToggle: {
      position: 'absolute',
      right: '10px',
      top: '12px',
      fontSize: '18px',
      cursor: 'pointer'
    }
  };

  // Header styles
  const headerStyles = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    transition: 'all 0.3s ease',
    backgroundColor: isScrolled ? '#ffffff' : '#ffffffdc',
    boxShadow: isScrolled ? '0 2px 10px rgba(0,0,0,0.1)' : 'none',
    // height: '80px'
  };

  return (
    <header className="header-section header-section--style2" style={headerStyles}>
      <div className="header-bottom">
        <div className="container-fluid">
          <div className="header-wrapper" style={{ height: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'nowrap' }}>
            <div className="logo">
              <Link to="/" onClick={closeMenu}>
                <img className="dark" src="assets/images/new/Logo.png" alt="logo" />
              </Link>
            </div>

            {/* Desktop Menu */}
            <div className="menu-area" style={!isMobile ? {} : { display: 'none' }}>
              <ul className="menu menu--style1">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/about">About Us</Link>
                </li>
                <li className="has-dropdown">
                  <Link >Products
                    <i class="fa-solid fa-caret-down m-0"></i>
                  </Link>
                  <ul className="submenu">
                    <li><Link to="/xts">XTS</Link></li>
                    <li><Link to="/ipo">IPO</Link></li>
                    <li><Link to="/mutual-fund">Mutual Fund</Link></li>
                    <li><Link to="/stoxxo">Stoxxo</Link></li>
                  </ul>
                </li>
                <li>
                  <Link to="/pricing">Pricing</Link>
                </li>

                <li className="has-dropdown">
                  <Link >Investor Type
                    <i class="fa-solid fa-caret-down m-0"></i>
                  </Link>
                  <ul className="submenu">
                    <li><Link to="/uhni">UHNI</Link></li>
                    <li><Link to="/nri-fpi">NRI/FPI</Link></li>
                    <li><Link to="/retail">Retail</Link></li>
                  </ul>
                </li>
                <li>
                  <Link to="/technology">Trading Platform</Link>
                </li>
                <li>
                  <Link to="/download">Download</Link>
                </li>
                {/* <li>
                  <Link to="/investor-type">Solution</Link>
                </li> */}
                {/* <li className="has-dropdown">
                  <Link to="/solutions">Solution
                   <span className="dropdown-arrow">▼</span>
                  </Link>
                  <ul className="submenu">
                    <li><Link to="/services">Services</Link></li>
                    <li><Link to="/services-details">Services Details</Link></li>
                  </ul>
                </li> */}

                <li>
                  <Link to="/contact">Contact</Link>
                </li>

              </ul>
            </div>

            <div className="header-action">
              <div className="menu-area" style={{ display: 'flex', alignItems: 'center' }}>
                <div className="header-btn">
                  <Link to="https://backoffice.asiaticstock.in:8085/capexweb/capexweb/" className="trk-btn trk-btn--border trk-btn--primary">
                    <span>Back Office Login</span>
                  </Link>
                </div>

                <div className="header-btn">
                  <Link to="https://trading.asiaticstock.in/#!/app" className="trk-btn trk-btn--border trk-btn--primary">
                    <span>Login</span>
                  </Link>
                </div>


                {/* Mobile Menu Toggle */}
                {isMobile && (
                  <div
                    style={mobileStyles.hamburger}
                    onClick={toggleMenu}
                    className="hamburger-icon"
                  >
                    <span style={{
                      ...mobileStyles.hamburgerLine,
                      ...(isMenuOpen ? {
                        transform: 'rotate(45deg) translate(5px, 6px)'
                      } : {})
                    }}></span>
                    <span style={{
                      ...mobileStyles.hamburgerLine,
                      ...(isMenuOpen ? {
                        opacity: 0
                      } : {})
                    }}></span>
                    <span style={{
                      ...mobileStyles.hamburgerLine,
                      ...(isMenuOpen ? {
                        transform: 'rotate(-45deg) translate(5px, -6px)'
                      } : {})
                    }}></span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu Content */}
      {isMobile && (
        <>
          <div
            className="mobile-menu-area"
            style={isMenuOpen ? mobileStyles.menuArea : { ...mobileStyles.menuArea, left: '-100%' }}
          >


            <ul style={mobileStyles.menuList}>
              <li style={mobileStyles.menuItem}>
                <Link to="/" onClick={closeMenu} style={{ color: '#333', textDecoration: 'none' }}>Home</Link>
              </li>

              <li style={mobileStyles.menuItem}>
                <Link to="/about" onClick={closeMenu} style={{ color: '#333', textDecoration: 'none' }}>About Us</Link>
              </li>

              {/* Products Submenu */}
              <li style={mobileStyles.menuItem}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Link onClick={closeMenu} style={{ color: '#333', textDecoration: 'none' }}>Products</Link>
                  <span
                    style={mobileStyles.submenuToggle}
                    onClick={(e) => {
                      e.preventDefault();
                      toggleSubmenu('products');
                    }}
                  >
                    {openSubmenu === 'products' ? '−' : '+'}
                  </span>
                </div>
                <ul style={{
                  ...mobileStyles.submenu,
                  display: openSubmenu === 'products' ? 'block' : 'none'
                }}>
                  <li style={mobileStyles.menuItem}><Link to="/xts" onClick={closeMenu} style={{ color: '#666', textDecoration: 'none' }}>XTS</Link></li>
                  <li style={mobileStyles.menuItem}><Link to="/ipo" onClick={closeMenu} style={{ color: '#666', textDecoration: 'none' }}>IPO</Link></li>
                  <li style={mobileStyles.menuItem}><Link to="/mutual-fund" onClick={closeMenu} style={{ color: '#666', textDecoration: 'none' }}>Mutual Fund</Link></li>
                  <li style={mobileStyles.menuItem}><Link to="/stoxxo" onClick={closeMenu} style={{ color: '#666', textDecoration: 'none' }}>Stoxxo</Link></li>
                </ul>
              </li>

              {/* Pricing */}
              <li style={mobileStyles.menuItem}>
                <Link to="/pricing" onClick={closeMenu} style={{ color: '#333', textDecoration: 'none' }}>Pricing</Link>
              </li>

              {/* Investor Type Submenu */}
              <li style={mobileStyles.menuItem}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Link to="/investor-type" onClick={closeMenu} style={{ color: '#333', textDecoration: 'none' }}>Investor Type</Link>
                  <span
                    style={mobileStyles.submenuToggle}
                    onClick={(e) => {
                      e.preventDefault();
                      toggleSubmenu('investor');
                    }}
                  >
                    {openSubmenu === 'investor' ? '−' : '+'}
                  </span>
                </div>
                <ul style={{
                  ...mobileStyles.submenu,
                  display: openSubmenu === 'investor' ? 'block' : 'none'
                }}>
                  <li style={mobileStyles.menuItem}><Link to="/uhni" onClick={closeMenu} style={{ color: '#666', textDecoration: 'none' }}>UHNI</Link></li>
                  <li style={mobileStyles.menuItem}><Link to="/nri-fpi" onClick={closeMenu} style={{ color: '#666', textDecoration: 'none' }}>NRI/FPI</Link></li>
                  <li style={mobileStyles.menuItem}><Link to="/retail" onClick={closeMenu} style={{ color: '#666', textDecoration: 'none' }}>Retail</Link></li>
                </ul>
              </li>

              <li style={mobileStyles.menuItem}>
                <Link to="/technology" onClick={closeMenu} style={{ color: '#333', textDecoration: 'none' }}>Trading Platform</Link>
              </li>

              <li style={mobileStyles.menuItem}>
                <Link to="/download" onClick={closeMenu} style={{ color: '#333', textDecoration: 'none' }}>Download</Link>
              </li>

              {/* Contact */}
              <li style={mobileStyles.menuItem}>
                <Link to="/contact" onClick={closeMenu} style={{ color: '#333', textDecoration: 'none' }}>Contact</Link>
              </li>
            </ul>

          </div>

          <div
            style={mobileStyles.overlay}
            onClick={closeMenu}
          />
        </>
      )}
    </header>
  );
}

export default Header;